export { Document as default } from './Document';
